// removed by extract-text-webpack-plugin
module.exports = {"Bowl":"PokeIngredient__Bowl__3h8nU","Salmon":"PokeIngredient__Salmon__33hFf","Tuna":"PokeIngredient__Tuna__2CZmF","Salad":"PokeIngredient__Salad__3B5fN","Tofu":"PokeIngredient__Tofu__2-cFB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Poke/PokeIngredient/PokeIngredient.css
// module id = 147
// module chunks = 0